import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
export default function CoverImage(_ref) {
  var post = _ref.post;
  var cmsUrl = 'https://cms.kreezus.tech';
  var imageUrl = "".concat(cmsUrl, "/assets/").concat(post === null || post === void 0 ? void 0 : post.thumbnail.id);
  console.log(imageUrl);

  var image = /*#__PURE__*/_jsx(Image, {
    width: 2000,
    height: 1000,
    alt: "Cover Image for ".concat(post === null || post === void 0 ? void 0 : post.title),
    src: imageUrl,
    className: cn('shadow-small', {
      'hover:shadow-medium transition-shadow duration-200': post === null || post === void 0 ? void 0 : post.slug
    }),
    priority: true
  });

  return /*#__PURE__*/_jsx("div", {
    className: "sm:mx-0",
    children: post.slug ? /*#__PURE__*/_jsx(Link, {
      href: "/blog/".concat(post === null || post === void 0 ? void 0 : post.slug),
      children: /*#__PURE__*/_jsx("a", {
        "aria-label": post === null || post === void 0 ? void 0 : post.title,
        children: image
      })
    }) : image
  });
}